import { Box, Divider, IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { BsFullscreen, BsFullscreenExit } from 'react-icons/bs';
import { DialogWrapperProps } from '..';

export interface DialogHeaderProps {
    title: string;
    onClose: any;
    enableFullScreen: DialogWrapperProps['enableFullScreen'];
    fullScreen: boolean;
    setFullScreen(e: boolean): void;
    divider?: boolean;
    loading?: boolean;
}

export const DialogHeader = ({ title, onClose, enableFullScreen, fullScreen, setFullScreen, divider = true, loading = false }: DialogHeaderProps) => (
    <>
        <Box width='100%' display='flex' justifyContent='space-between' alignItems='center'>
            <Typography variant='h5'>{title}</Typography>
            <Box>
                {enableFullScreen && (
                    <>
                        {fullScreen && (
                            <IconButton onClick={() => setFullScreen(false)}>
                                <BsFullscreenExit />
                            </IconButton>
                        )}
                        {!fullScreen && (
                            <IconButton onClick={() => setFullScreen(true)}>
                                <BsFullscreen />
                            </IconButton>
                        )}
                    </>
                )}
                <IconButton onClick={onClose} disabled={loading}>
                    <CloseIcon />
                </IconButton>
            </Box>
        </Box>
        {divider && <Divider />}
    </>
);
